class CubicBezier {
  constructor(p0, p1, p2, p3, segment = 50) {
    this.p0 = p0;
    this.p1 = p1;
    this.p2 = p2;
    this.p3 = p3;
    this.segment = segment;
  }

  get arcs() {
    let length = 0;
    let prev = { x: this.p0.x, y: this.p0.y };
    let t = 0;
    const arcsArr = new Array(this.segment + 1);

    for (let i = 0; i < this.segment + 1; i += 1) {
      t = i / this.segment;
      const { x, y } = this.getPoint(t);
      const dx = x - prev.x;
      const dy = y - prev.y;

      length += Math.sqrt(dx * dx + dy * dy);
      prev = { x, y };
      arcsArr[i] = length;
    }

    return arcsArr;
  }

  get length() {
    return this.arcs[this.arcs.length - 1];
  }

  bezier(p0, p1, p2, p3, t) {
    const first = (1 - t) ** 3 * p0;
    const second = 3 * t * (1 - t) ** 2 * p1;
    const third = 3 * t ** 2 * (1 - t) * p2;
    const fourth = t ** 3 * p3;
    return first + second + third + fourth;
  }

  getPoint(t) {
    const x = this.bezier(this.p0.x, this.p1.x, this.p2.x, this.p3.x, t);
    const y = this.bezier(this.p0.y, this.p1.y, this.p2.y, this.p3.y, t);
    return { x, y };
  }

  getT(targetLength) {
    let min = 0;
    let max = this.arcs.length - 1;
    let mid = Math.floor((min + max) / 2);

    while (min < max) {
      if (this.arcs[mid] < targetLength) min = mid + 1;
      else max = mid;

      mid = Math.floor((min + max) / 2);
    }

    return mid / this.arcs.length;
  }
}

exports.calCoords = (path, totalNodes) => {
  let cmdSegments = path.split(/(?=[A-Z])/).map((cmd) => cmd.trim());
  cmdSegments = cmdSegments.reduce(
    (acc, cmd) => {
      const type = cmd.charAt(0);
      const coord = cmd.slice(1).split(' ');
      const p = coord.map(Number);
      switch (type) {
        case 'M':
          return { ...acc, x: p[0], y: p[1] };
        case 'C':
          return {
            x: p[4],
            y: p[5],
            cmds: [
              ...acc.cmds,
              {
                type,
                p0: { x: acc.x, y: acc.y },
                p1: { x: p[0], y: p[1] },
                p2: { x: p[2], y: p[3] },
                p3: { x: p[4], y: p[5] },
              },
            ],
          };
        default:
          return acc;
      }
    },
    { x: 0, y: 0, cmds: [] },
  );

  const curves = cmdSegments.cmds.map((cmd) => new CubicBezier(cmd.p0, cmd.p1, cmd.p2, cmd.p3));
  const curveSeg = curves.reduce((acc, curve) => [...acc, acc[acc.length - 1] + curve.length], [0]);

  const curveSegPercent = curveSeg.map((seg) => seg / curveSeg[curveSeg.length - 1]);
  const nodesPercent = (nodes) => {
    if (nodes === 0) return [];
    if (nodes === 1) return [0.5];
    return Array.from({ length: nodes }, (_, i) => i / (nodes - 1));
  };

  const nodes = nodesPercent(totalNodes).map((node) => {
    let curveIdx = curveSegPercent.findIndex((seg) => seg >= node) - 1;
    if (curveIdx < 0) curveIdx = 0;

    const curve = curves[curveIdx];

    const prevSeg = curveSegPercent[curveIdx];
    const remain = (node - prevSeg) / (curveSegPercent[curveIdx + 1] - prevSeg);

    return curve.getPoint(curve.getT(remain * curve.length));
  });
  return nodes;
};
